import type { QuestionModule } from "../contracts";
import {
  questionGroupCore,
  type QuestionGroupDefinition,
  type QuestionGroupDraft,
  type QuestionGroupEvent,
  type QuestionGroupRaw,
  type QuestionGroupResponse,
} from "./core";

const QuestionGroupView = () => null;

export const questionGroupModule: QuestionModule<
  QuestionGroupRaw,
  QuestionGroupDefinition,
  QuestionGroupDraft,
  QuestionGroupEvent,
  QuestionGroupResponse
> = {
  type: "question_group",
  galleryFeatures: ["baseline", "images"],
  core: questionGroupCore,
  prompt: (definition) => ({ content: definition.heading }),
  views: {
    default: {
      id: "default",
      label: "Group",
      component: QuestionGroupView,
      arrangements: ["compact", "wide"],
      requiredControls: [],
    },
  },
  defaultDisplay: { view: "default" },
  controls: (_definition, _draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.submit,
      action: { type: "submit" },
    },
  }),
};
